module.exports = __webpack_public_path__ + "static/media/animated_logo.ee04d522.svg";